const DevelopmentMode = () => {
    return(
        <>
            <div className="DevelopmentMode">
                <i class="fa-solid fa-code"></i>
                <p>Page under construction. We’ll be back shortly!</p>
            </div> 
        </>
    )
}

export default DevelopmentMode;